import React, { forwardRef } from 'react';
import { Button as AntButton } from 'antd';
import { ButtonProps } from 'antd/lib/button';
import styles from './styles.module.scss';
import RevButton from './revButton';

interface CustomButtonProps extends ButtonProps {
  children: React.ReactNode;
  width?: 'full' | 'auto';
  type?: 'primary'  | 'link' | 'text' | 'default' | 'dashed';
}

const Button = forwardRef<HTMLButtonElement, CustomButtonProps>(({ 
  children, 
  className, 
  type,
  size = 'large',
  width = 'auto',
  ...props 
}, ref) => {
  return (
    <AntButton
      ref={ref}
      type={type || 'primary'}
      size={size}
      className={`${styles.button} ${className || ''} ${width === 'full' ? styles.fullWidth : ''}`}
      {...props}
    >
      {children}
    </AntButton>
  );
});

Button.displayName = 'Button';

export default Button;
export { RevButton }; 